import React from "react";
import { Link } from "react-router-dom";

// UI
import { P, Section, Button, Row, Col } from "../../../ui";

function MissingEmail({ user }) {
  if (user && user.isLoaded && (!user.item.email || user.item.email === "")) {
    return (
      <Section theme="warning">
        <Row align="center">
          <Col padding="no" lg={10} md={9} sm={12} xs={12}>
            <P size="small">
              Необходимо заполнить email, чтобы вам приходили уведомления и в
              случае, если вы забудите пароль, сможете легко его восстановить.
            </P>
          </Col>
          <Col padding="no" text="right" lg={2} md={3} sm={12} xs={12}>
            <Button
              theme="white-primary"
              size="s"
              type="as"
              as={Link}
              block={true}
              to="/account/settings"
            >
              Настройки
            </Button>
          </Col>
        </Row>
      </Section>
    );
  } else {
    return null;
  }
}

export default MissingEmail;
